import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useDebouncedCallback } from 'Hooks/useDebounced/useDebounced';
import { searchEntityPlayer, searchNextEntityPlayer } from 'Store/entities/entity-players/entity-players.thunk';

import { EntityType } from '../../AudienceGroupList/types';

export type UseAudiencePlayersSearchHook = (args: {
  entityType: EntityType;
  entityId: number;
  audienceHasBeenReset: boolean;
}) => {
  nameFilter: string;
  setNameFilter: (name: string) => void;
  fetchNextPlayers: () => void;
};

export const useAudiencePlayersSearch: UseAudiencePlayersSearchHook = ({
  entityId,
  entityType,
  audienceHasBeenReset,
}) => {
  const dispatch = useDispatch();
  const [nameFilter, setNameFilter] = useState('');

  const fetchInitialPlayers = useCallback(() => {
    dispatch(searchEntityPlayer({ entity: { entityId, entityType }, searchParams: { name: nameFilter, offset: 0 } }));
  }, [nameFilter]);

  useEffect(() => {
    dispatch(searchEntityPlayer({ entity: { entityId, entityType }, searchParams: { name: nameFilter, offset: 0 } }));
  }, [nameFilter]);

  useEffect(() => {
    fetchInitialPlayers();
  }, [audienceHasBeenReset]);

  const fetchNextPlayers = useCallback(() => {
    {
      dispatch(searchNextEntityPlayer({ entityId }));
    }
  }, [entityId]);

  return {
    nameFilter,
    setNameFilter: useDebouncedCallback(setNameFilter, 500),
    fetchNextPlayers,
  };
};
